import React from 'react';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import BasedataAddress from "./BasedataAddress";
import BasedataContacts from "./BasedataContacts";
import ContactAction from "../DetailsFooter/ContactAction";
import {StyledEmailIcon} from "../../styled";
import {BaseDataType} from "../types";

export type BaseDataContentProps = {
    baseData: BaseDataType;
    recruitEmail: string;
    mandate: number;
}

const BaseDataContent: React.FC<BaseDataContentProps> = ({baseData, recruitEmail, mandate}) => {

    if(!baseData || Object.entries(baseData).length === 0 ) return null;

    return (
        <>
            {baseData?.recruitIsCompany ?
                <Box>
                    <Typography variant="body1">{baseData?.recruitCompany}</Typography>
                    <BasedataAddress recruitIsCompany={baseData.recruitIsCompany}
                                     postCode={baseData?.recruitPostCode} city={baseData?.recruitCity}
                                     street={baseData?.recruitStreet} houseNumber={baseData?.recruitHouseNumber}
                                     streetHouseNumber={baseData?.recruitStreetHouseNumber}
                                     country={baseData?.recruitCountry} phone={baseData?.recruitPhone}
                                     mobile={baseData?.recruitMobile} fax={baseData?.recruitFax}/>
                    <BasedataContacts contacts={baseData?.recruitContacts}
                                      recruitIsCompany={baseData.recruitIsCompany}
                                      postCode={baseData?.recruitPostCode} city={baseData?.recruitCity}
                                      street={baseData?.recruitStreet}
                                      houseNumber={baseData?.recruitHouseNumber}
                                      streetHouseNumber={baseData?.recruitStreetHouseNumber}
                                      country={baseData?.recruitCountry} phone={baseData?.recruitPhone}
                                      mobile={baseData?.recruitMobile} fax={baseData?.recruitFax}
                                      mandate={mandate}
                    />

                </Box>
                : <Box>
                    <BasedataContacts contacts={baseData?.recruitContacts}
                                      recruitIsCompany={baseData.recruitIsCompany}
                                      postCode={baseData?.recruitPostCode} city={baseData?.recruitCity}
                                      street={baseData?.recruitStreet}
                                      houseNumber={baseData?.recruitHouseNumber}
                                      streetHouseNumber={baseData?.recruitStreetHouseNumber}
                                      country={baseData?.recruitCountry} phone={baseData?.recruitPhone}
                                      mobile={baseData?.recruitMobile} fax={baseData?.recruitFax}
                                      mandate={mandate}
                    />
                </Box>}
            <ContactAction href={recruitEmail} Icon={<StyledEmailIcon/>} type="email"/>
        </>
    );
};

export default BaseDataContent;